import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrgTreeComponent } from './org-tree.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [{ path: '', component: OrgTreeComponent, canActivate: [MsalGuard] }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class OrgTreeRoutingModule {}
